<template>
  <div class="hrisk">
    <div class="row top">
      <div class="col header-text">
        <div class="pre-header"></div>
        <h1>{{ $t('views.risk.investingAnd') }}<span class="blue">{{ $t('views.risk.risk') }}</span></h1>
        <h3>{{ $t('views.risk.allInvestmentsCome') }}</h3>
      </div>
      <div class="col top-block">
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col risks">
              <div class="risk">
                <div class="risk-header">{{ $t('views.risk.creditDefaultRisk') }}</div>
                <div class="risk-description">
                  <p>{{ $t('views.risk.theRiskThat') }}</p>
                  <p>{{ $t('views.risk.onTheIncome') }}</p>
                  <p>{{ $t('views.risk.additionallyToThe') }}</p>
                </div>
              </div>
              <div class="risk">
                <div class="risk-header">{{ $t('views.risk.loanOriginatorCompanyRisk') }}</div>
                <div class="risk-description">
                  <p>{{ $t('views.risk.theRiskThat1') }}</p>
                  <p>{{ $t('views.risk.inTheUnlikely') }}</p>
                  <p>{{ $t('views.risk.throughTheWay') }}</p>
                  <p>{{ $t('views.risk.shouldTheLoan') }}</p>
                </div>
              </div>
              <div class="risk">
                <div class="risk-header">{{ $t('views.risk.platformRisk') }}</div>
                <div class="risk-description">
                  <p>{{ $t('views.risk.theRiskThat2') }}</p>
                  <p>{{ $t('views.risk.inTheUnlikely1') }}</p>
                </div>
              </div>
              <div class="risk">
                <div class="risk-header">{{ $t('views.risk.marketRisk') }}</div>
                <div class="risk-description">
                  <p>{{ $t('views.risk.likeWithAny') }}</p></div>
              </div>
              <div class="risk">
                <div class="risk-header">{{ $t('views.risk.regulatory_ComplianceRisk') }}</div>
                <div class="risk-description">
                  <p>{{ $t('views.risk.theRiskOf') }}</p>
                  <p>{{ $t('views.risk.inOrderTo') }}</p>
                </div>
              </div>
              <div class="risk">
                <div class="risk-header">{{ $t('views.risk.reinvestmentRisk') }}</div>
                <div class="risk-description">
                  <p>{{ $t('views.risk.theRiskOf1') }}</p>
                  <p>{{ $t('views.risk.weRecommendUsing') }}</p>
                </div>
              </div>
              <div class="risk">
                <div class="risk-header">{{ $t('views.risk.liquidityRisk') }}</div>
                <div class="risk-description">
                  <p>{{ $t('views.risk.theRiskOf2') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="equal-opportunity">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                <div class="circle">{{ $t('views.risk.ofInvestors') }}</div>
              </div>
              <div class="col-12 col-md-5 col-lg-5 col-xl-5 text">
                <div class="head">
                  <span class="blue">{{ $t('views.risk.ofInvestors1') }}</span>{{ $t('views.risk.withAtLeast') }}<span class="blue">{{ $t('views.risk.invested') }}</span>
                </div>
                <div class="info">{{ $t('views.risk.lendingCompaniesProvide') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="home-start-investing">
            <h2>{{ $t('views.risk.startInvestingToday') }}</h2>
            <div class="detail-info">{{ $t('views.risk.earnUpTo') }}</div>
            <get-started/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetStarted from '../components/GetStarted'

export default {
  name: 'Risk',
  components: {
    GetStarted
  }
}
</script>

<style scoped lang="scss">

.hrisk {
  .top {
    border-bottom: 1px solid #c3c3c3;
    margin-bottom: 10px;
  }
}

.blue {
  color: #30A7FE;
}

.header-text {
  text-align: center;
  margin: 82px auto 16px 10%;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 64px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 55px;

  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    text-align: center;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 45px;
    max-width: 826px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.ensuring-fairness {
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;

  h2 {
    margin-top: 50px;
    margin-bottom: 16px;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
  }

  img {
    max-width: 642px;
    width: 100%;
    margin-bottom: 35px;
  }
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url("../assets/equal-opportunity.png");
  background-position: left 0;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .circle {
    background: #30A7FE;
    border-radius: 108px;
    border: 10px solid #30A7FE;
    font-weight: bold;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #FFFFFF;
    max-width: 270px;
    font-style: normal;
    padding: 38px;
    margin: 120px auto auto 56%;
    @media screen and (min-width: 1200px) {
      margin: 120px auto auto 58%;
    }
    @media (min-width: 768px) and (max-width: 1200px) {
      margin: 120px auto auto 50%;
    }
  }

  .text {
    margin-top: 100px;
    margin-bottom: 80px;
    margin-left: 50px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 28px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 10px 16px 0;
    }
  }
}

.top-block {
  background-image: url("../assets/invest-page-escalator-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
}

.black-box {
  background: #000000;
  margin: 24px 0;
  padding: 25px;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: #FFFFFF;
    margin-bottom: 10px;
  }

  .desc {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    color: #6E777A;
  }
}

.risk-box {
  margin: 5px;
  padding: 5px;

  .title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: #000000;
    flex: none;
    order: 0;
    align-self: flex-start;
    margin: 36px 0;
    border-bottom: 1px solid #6E777A;
  }

  .desc {
    font-size: 16px;
    line-height: 24px;
    color: #6E777A;
  }
}

.risk {
  /*text-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);*/
  font-size: 18px;
  line-height: 28px;
  margin-top: 5px;
  margin-bottom: 10px;

  .risk-header {
    font-weight: bold;
  }
}

.risks {
  margin-top: 25px;
}

@media only screen and (min-width: 320px) and (max-width: 480px) {
  .top-block {
    display: none;
  }
}

@media only screen and (max-width: 1024px) {

  .equal-opportunity {
    background: transparent;

    .text {
      margin: 10px
    }

    .circle {
      margin: 10px;
      padding-top: 85px;
      padding-bottom: 85px;
      border-radius: 130px
    }
  }
}
</style>
